import Chevron, { ChevronDirection } from 'components/Icons/Chevron'
import React, { useState } from 'react'
import styled from 'styled-components'
import { color } from 'utils/styledHelper'

type CollapseProps = {
  children: React.ReactNode
  expandFirst?: boolean
  header: React.ReactNode
}

const Wrapper = styled.div`
  border-top: 1px solid ${color('light')};
  padding: 1rem 0;

  :last-child {
    border-bottom: 1px solid ${color('light')};
  }
`

const CollapseTitle = styled.div<{ collapsed: boolean }>`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  cursor: pointer;
  display: flex;
  margin: 0;
  padding-top: 0.5rem;

  & > div {
    flex: 1;
  }
`

const CollapseBody = styled.div<{ collapsed: boolean }>`
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.25rem;
  max-height: ${(p) => (p.collapsed ? '0' : '20rem')};
  overflow: hidden;
  margin: 0;
  transition: margin 0.5s, max-height 0.5s;
`

const CollapseGroup = ({ children, expandFirst, header }: CollapseProps) => {
  const [collapsed, setCollapsed] = useState(!expandFirst)

  return (
    <Wrapper>
      <CollapseTitle collapsed={collapsed} onClick={() => setCollapsed(!collapsed)}>
        <div>{header}</div>
        <Chevron direction={collapsed ? ChevronDirection.Down : ChevronDirection.Up} />
      </CollapseTitle>
      <CollapseBody collapsed={collapsed}>{children}</CollapseBody>
    </Wrapper>
  )
}

export default CollapseGroup
